module.exports = __webpack_public_path__ + "img/linkedin.d72c7cdb.svg";